import { createStore } from "vuex";
import Auth from "@/store/auth";
import { vuexLocal } from "@/store/persistence/persistance";
import GlobalMessage from "@/store/global_message";
import Users from "@/store/users";
import Pages from "@/store/pages";

export default createStore({
  modules: {
    globalMessage: new GlobalMessage(),
    auth: new Auth(),
    users: new Users(),
    pages: new Pages(),
  },
  plugins: [vuexLocal.plugin],
});
